<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account-clock-outline
      </v-icon> Check-Out
    </h2>
    <br>
    <v-card color="#CFD8DC">
      <div class="steps-style">
        <p><span :style="step1Success">Location Verification</span> -> <span :style="step2Success">Job Status</span> <br> -> Review Details</p>
      </div>
      <hr>
      <v-stepper
        v-model="userCheckOut"
        light
        class="my-stepper-style"
      >
        <v-stepper-header>
          <v-stepper-step
            :complete="userCheckOut > 1"
            step="1"
            color="#FF3700"
          />

          <v-divider />

          <v-stepper-step
            :complete="userCheckOut > 2"
            step="2"
            color="#FF3700"
          />

          <v-divider />

          <v-stepper-step
            :complete="userCheckOut > 3"
            color="#FF3700"
            step="3"
          />
        </v-stepper-header>
      </v-stepper>
      <div>
        <location-verification
          v-if="showLocationVerificationPage"
          @verification-completed="toSecondStep"
        />
        <gather-job-status
          v-if="showJobStatusPage"
          @job-status-stored="toThirdStep"
        />
        <review-checkout-details
          v-if="showReviewCheckOutPage"
          @checkout-completed="checkOutCompleted"
        />
      </div>
    </v-card>
  </v-container>
</template>
<script>
import LocationVerification from './LocationVerification.vue';
import GatherJobStatus from './GatherJobStatus.vue';
import ReviewCheckOutDetails from './ReviewCheckOutDetails.vue';

export default {
  name: 'CheckOutLandingPage',
  components: {
    'location-verification': LocationVerification,
    'gather-job-status': GatherJobStatus,
    'review-checkout-details': ReviewCheckOutDetails,
  },
  data () {
    return {
      userCheckOut: 1,
      showLocationVerificationPage: true,
      step1SuccessColor: '',
      showJobStatusPage: false,
      step2SuccessColor: '',
      showReviewCheckOutPage: false,
    };
  },
  computed: {
    step1Success () {
      return `color:${this.step1SuccessColor}`;
    },
    step2Success () {
      return `color:${this.step2SuccessColor}`;
    },
  },
  async mounted () {
    await this.fetchActiveCheckInDetails();
    await this.getOrganizationSettings();
  },
  methods: {
    async fetchActiveCheckInDetails () {
      this.loading = true;
      const checkInId = localStorage.getItem('checkIn');
      this.$store.dispatch('swiftuser/fetchActiveCheckInDetails', {
        checkInId: checkInId,
      }).then(response => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$router.push({ name: 'HomePage' });
      });
    },
    async getOrganizationSettings () {
      this.loading = true;
      await this.$store.dispatch('userprofile/fetchOrganizationSettings').then(response => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$router.push({ name: 'HomePage' });
      });
    },
    toSecondStep () {
      this.step1SuccessColor = '#00796B';
      this.userCheckOut = 2;
      this.showLocationVerificationPage = false;
      this.showReviewCheckOutPage = false;
      this.showJobStatusPage = true;
    },
    toThirdStep () {
      this.step2SuccessColor = '#00796B';
      this.userCheckOut = 3;
      this.showLocationVerificationPage = false;
      this.showJobStatusPage = false;
      this.showReviewCheckOutPage = true;
    },
    checkOutCompleted () {
      this.$router.push({ name: 'HomePage' });
    },
  },
};
</script>
<style scoped>
.my-stepper-style {
  background-color: #CFD8DC;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.steps-style {
  text-align: center;
  padding-top: 25px;
  color: #37474F;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-weight: 500;
  font-size: 14px;
}
</style>
